import React, { useEffect, useState } from "react";
import ReusableTable from "../../../../components/common/table";
import { Button, Popconfirm, Space } from "antd";
import { ReactComponent as AddSvg } from "../../../../assets/images/add.svg";
import FilterComponent from "../../../../components/common/filter";
import { useNavigate } from "react-router";
import ConfirmModal from "../../../../components/common/alert-popup";
import { ReactComponent as ViewSvg } from "../../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../../assets/images/action/Shield Cross.svg";
import CommonFilter from "../../../../components/common/filter";
import { Tooltip } from "antd";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { useDebounce } from "../../../../customHooks";
import { fetchQueryLogs, fetchUserLogs } from "../../../../redux/reducer/LogsSlice";
import { useDispatch, useSelector } from "react-redux";

const AllQueries = () => {
  const [filteredData, setFilteredData] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });

  const {userQueries, userCountQueries, loadingQueries} = useSelector(prev => prev?.userLogs) 


  const [currentPage, setCurrentPage] = useState(1);

  const [searchParams, setSearchParams] = useSearchParams();
  // Convert URLSearchParams to usable object
const getInitialParams = () => {
  const page = parseInt(searchParams.get("page")) || 1;
  const size = parseInt(searchParams.get("size")) || 10;
  const search_key = searchParams.get("search_key") || "all";
  const search_value = searchParams.get("search_value") || "";
  const status = searchParams.get("status");
  const type = searchParams.get("type");
  const position = searchParams.get("position");

  return {
    page,
    size,
    search_key,
    search_value,
    status: status !== null ? Number(status) : undefined,
    type: type !== null ? Number(type) : undefined,
    position: position !== null ? Number(position) : undefined,
  };
};

const [tableParams, setTableParams] = useState(getInitialParams());

useEffect(() => {
  const params = {
    page: tableParams.page,
    size: tableParams.size,
    search_key: tableParams.search_key,
    search_value: tableParams.search_value,
  };

  if (tableParams.status !== undefined) params.status = tableParams.status;
  if (tableParams.type !== undefined) params.type = tableParams.type;
  if (tableParams.position !== undefined) params.position = tableParams.position;

  setSearchParams(params);
}, [tableParams, setSearchParams]);


const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

useEffect(()=>{
  dispatch(fetchQueryLogs(tableParams))
},[dispatch,
  tableParams.page, tableParams.size,
  debouncedSearchValue,
  tableParams.status,
  tableParams.type,
  tableParams.position,
])



const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"], 
    showSizeChanger: true, 
    showQuickJumper: true, 
    total: userCountQueries || 1, 
    current: tableParams.page, 
    pageSize: tableParams.size, 
    type: tableParams.type,
    onChange: (page, pageSize) => {
      setCurrentPage(page); 
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };




  const handleDateFilter = (dates, dateStrings) => {
    if (!dates) {
      setFilteredData(dataSource);
      return;
    }
    const [startDate, endDate] = dateStrings;
    const filtered = dataSource?.filter((item) => {
      const itemDate = new Date(item?.date_added);
      return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
    });
    setFilteredData(filtered);
  };
  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
  };

  const handleConfirm = () => {
    console.log(`Confirmed ${modalConfig.actionType} action`);
    closeModal();
  };
  const handleSearch = (searchText) => {
    const filtered = dataSource.filter((item) =>
      item.tenant_name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  };

  

  const columns = [
    {
        title: "Sr. No.",
        dataIndex: "sr_no",
        key: "sr_no",
        render: (text, record, index) => (tableParams.page - 1) * tableParams.size + index + 1, 
        width: "100px"
      },
    {
      title: "User Name",
      dataIndex: "user_name_en",
      key: "user_name",
      type: "search",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      type: "search",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      type: "search",
    },
    {
      title: "Query",
      dataIndex: "query",
      key: "query",
      type: "search",
      render: (text) => (
        <Tooltip title={text}>
          <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "inline-block", maxWidth: 150 }}>
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
        title: "Created at",
        dataIndex: "created_at",
        key: "date",
        type: "date",
        // render: (date) => dayjs(date).format("MM-DD-YYYY"),
        render: (date) => {
            const dateObject = new Date(date);
            const day = String(dateObject.getUTCDate()).padStart(2, '0');       
            const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0'); 
            const year = dateObject.getUTCFullYear();                          
            return `${month}-${day}-${year}`;
          },
      },
   
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   key: "actions",
    //   render: (_, record) => (
    //     <div>
    //       {/* Replace with your own action buttons */}
    //        <button 
    //     //    onClick={() => handleEdit(record)}
    //        >Edit</button> 
    //       <button 
    //     //   onClick={() => handleDelete(record)}
    //       >Delete</button> 
    //     </div>
    //   ),
    // },
  ];
  

  const dataSource = [
    {
      key: "1",
      sr_no: "1",
      user_name: "Ajit User",
      email: "ajit.singh1305@gmail.com",
      title: "Issue with login",
      query: "Okay, here are a couple of examples of small, two-line normal text queries, assuming you mean questions or requests you might type into a search engine or ask a language model:",
      created_at: "2025-22-04",
      updated_at: "2025-22-04",
    },
    {
      key: "2",
      sr_no: "2",
      user_name: "Ajit User",
      email: "ajit.singh1305@gmail.com",
      title: "Podcast upload failed",
      query: "Write a short poem about rain. Summarize the main points of this article",
      created_at: "2025-22-04",
      updated_at: "2025-22-04",
    },
    {
      key: "3",
      sr_no: "3",
      user_name: "Ajit User",
      email: "ajit.singh1305@gmail.com",
      title: "Unable to update profile",
      query: "What's the weather like in Noida right now? Find nearby coffee shops that are open.",
      created_at: "2025-22-04",
      updated_at: "2025-22-04",
    },
  ];
  

  const actionItems = () => [
    {
      key: "view",
      label: (
        <>
          <ViewSvg style={{ marginRight: 8 }} />
          View Details
        </>
      ),
      onClick: (record) => navigate("view"),
    },
   
   
    // {
    //   key: "delete",
    //   label: (
    //     <>
    //       <DeleteSvg style={{ marginRight: 8, color: "red" }} />
    //       Delete Query
    //     </>
    //   ),
    //   onClick: () => showModal("delete"),
    // },
  ];

  const handleFilterChange = (key, value, reset = false) => {
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
        };
      }
      if (key === "status" || key==="type" || key === "position") {
        return {
          ...prev,
          [key]: value,
          search_key: "",
          search_value: "",
        };
      }
      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };
  return (
    <div>
      {/* <div className="addBx">
        <div className="filterBx">
          <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
            />
          </Space>
        </div>
        <Button
          type="primary"
          icon={<AddSvg />}
          onClick={() => navigate("add-authors")}
        >
          Add Authors
        </Button>
      </div> */}
      <div className="tableHeading">List of Queries Added</div>
      <ReusableTable
        columns={columns}
        dataSource={userQueries}
        loading={loadingQueries}
        paginationConfig={paginationConfig}
        // actionItems={actionItems}
      />
      <ConfirmModal
        titlePrefix="Author"
        messagePrefix="Author"
        open={modalConfig.open}
        onClose={closeModal}
        onConfirm={handleConfirm}
        actionType={modalConfig.actionType}
      />
    </div>
  );
};

export default AllQueries;
